import React from 'react'
import sliceItems from "./sliceItems"
import Styles from "./ActivitiesScreen.module.css"
import anime from "animejs"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import { Loader } from 'semantic-ui-react'


class ActivitiesScreen extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            loaded: false,
            appName: '',
            ListActivities: [],
            currentPage: 2,
            rowsPerPage: 6,
            slicedList: [], //Activities.slice(0, 3),
            sendNextPage: (nextScreen) => {
                this.props.nextPageProp(nextScreen)
            },
        }
    }
    componentDidMount() {
        console.log('activities')
    //    this.setUpComponent()
    }
    componentWillUnmount() {
        clearInterval(this.interval)
    }
    //setUpComponent = async () => {const Activities = await this.getData()}
    getData = async () => {
        try {

            const snapShot = await firebase.firestore().collection('TareasAsignadas').where('estado', '==', 'pendiente').get()
            const appName = (await firebase.firestore().collection('Info').doc('info').get()).data().nombre
            const ListActivities = []
            for (let i = 0; i < snapShot.docs.length; i++) {
                if (!snapShot.docs[i].exists) break
                const activity = snapShot.docs[i]
                ListActivities.push({
                    name: activity.data().empleados,
                    activity: activity.data().nombreActividad,
                    days: DateUtilities.GetDayDifference(activity.data().fechaEntrega.toDate(), DateUtilities.today()),
                    description: activity.data().descripcion,
                    sector: activity.data().areaAsignada,
                })
            }
            if (ListActivities.length === 0) return this.state.sendNextPage('PunctualityScreen')
            this.setState({
                ListActivities: ListActivities,
                slicedList: ListActivities.slice(0, this.state.rowsPerPage),
                appName: appName,
                loaded: true,
            })
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.ListActivities !== this.state.ListActivities) {
            this.setTimer(this.state.ListActivities)
        }
    }
    setTimer = (Activities) => {
        let maxSection = Math.ceil(Activities.length / this.state.rowsPerPage)
        this.interval = setInterval(() => {
            if (this.state.currentPage <= maxSection) {
                anime({
                    targets: 'table',
                    translateX: { value: '120%', duration: 500 },
                    direction: 'reverse',
                })
                const slicedList = sliceItems(Activities, this.state.rowsPerPage, this.state.currentPage)
                const currentPage = this.state.currentPage + 1
                this.setState({
                    slicedList: slicedList,
                    currentPage: currentPage,
                })
            } else if (this.state.currentPage > maxSection) {
                const rng = Math.random()
                console.log(rng)
                if (rng < 0.60) {
                    //50% of the time restarts the index
                    anime({
                        targets: 'table',
                        translateX: { value: '120%', duration: 500 },
                        direction: 'reverse',
                    })
                    const slicedList = sliceItems(Activities, this.state.rowsPerPage, 1)
                    return this.setState({
                        slicedList: slicedList,
                        currentPage: 2,
                    })
                }
                if (rng < 0.80) {
                    return this.state.sendNextPage('PunctualityScreen')
                }
                //if (rng < 0.90) //25% of the time change to Birhday Screen
                    //return this.state.sendNextPage('HarvestScreen')
                //25% of the time change to Puntuality Screen
                return this.state.sendNextPage('BirthdayScreen')
            }
        }, 15000)
    }
    render() {

        let slicedList = this.state.slicedList;
        return (
            <>
                <Loader className={Styles.loader} active={!this.state.loaded}></Loader>
                <div className={`${Styles.container}`} hidden={!this.state.loaded}>

                    <header>
                        <span className={`${Styles.title}`}>Actividades ({this.state.appName})</span>
                    </header>

                    <table className={`${Styles.table}`}>
                        <tbody>
                            <tr className={`${Styles.header}`}>
                                <th>Nombre</th>
                                <th>Actividad</th>
                                <th>Días</th>
                                <th>Descripción</th>
                                <th>Sector/Tunel-Surco</th>
                            </tr>
                            {
                                slicedList.map((item, i) => (

                                    <tr key={i} className={`${Styles.row}`}>
                                        <td>{item.name}</td>
                                        <td>{item.activity}</td>
                                        <td>{item.days}</td>
                                        <td>{item.description}</td>
                                        <td>{item.sector}</td>
                                    </tr>

                                ))

                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
}


export default ActivitiesScreen